import {Injectable} from '@angular/core';
import {createNumberFormat} from '../../common/formatters';
import {Asset} from '../../models/asset';
import {createDisplayDecimal, DisplayDecimal, scaleToDecimalPlaces} from '../symbol-decimals';
import {getAssetIcon} from './asset-icons';
import {AssetService} from './asset.service';
import {DisplayAsset} from './display-asset';

type DisplayDecimalFormatter = (value: number) => DisplayDecimal<string>;

@Injectable()
export class DisplayAssetFactory {

    private readonly formatByAssetCache = new WeakMap<Asset, DisplayDecimalFormatter>();

    constructor(
        private assetService: AssetService
    ) {}

    public createDisplayAsset(asset: Asset): DisplayAsset {
        const {name, symbol} = asset;
        const formatQty = this.getAssetQuantityFormatter(asset);
        const assetIcon = getAssetIcon(symbol);

        return {
            asset,
            name,
            symbol,
            assetIcon,
            formatQty
        };
    }

    public getAssetQuantityFormatter(asset: Asset): DisplayDecimalFormatter {
        asset = this.assetService.syncAssetWithCache(asset);

        let formatter = this.formatByAssetCache.get(asset);

        if (!formatter) {
            const numberFormat = createNumberFormat({
                isDecimalRequired: true,
                decimalCount:      scaleToDecimalPlaces(asset.qtyScale)
            });

            formatter = value => createDisplayDecimal(value, numberFormat);

            this.formatByAssetCache.set(asset, formatter);
        }

        return formatter;
    }

}
